<template v-slot="scope">
  <div class="MainVisual__back">
    <banner v-show="!isLoadingView" @updateLoadingBanner="updateLoadingBanner" />
    <div class="contents">
      <notification v-show="!isLoadingView" @updateNotification="updateNotification" />
      <schedule v-show="!isLoadingView" :key="scheduleForm" @reload="reloadComponent" />
      <tutorial-banner v-if="isNewUser" v-show="!isLoadingView" />
      <mindful-log v-show="!isLoadingView" />
      <melon-t-v v-show="!isLoadingView" @updateLoadingMelonTV="updateLoadingMelonTV" />
      <information v-show="!isLoadingView" @updateLoadingInformation="updateLoadingInformation" />
      <campaign-introduce v-show="!isLoadingView" />
      <cotree v-show="!isLoadingView" />
    </div>
    <modal-melon-t-v />
    <modal-survey />
    <pwa-prompt :deferred-prompt="deferredPrompt" />
  </div>
</template>

<script>
import Banner from '@/views/pages/home/components/Banner'
import Notification from './components/Notification'
import MindfulLog from '@/views/pages/home/components/MindfulLog'
import MelonTV from '@/views/pages/home/components/MelonTV'
import Information from '@/views/pages/home/components/Information'
import Schedule from '@/views/pages/home/components/Schedule'
import Cotree from '@/views/pages/home/components/Cotree'
import ModalMelonTV from '@/views/components/modals/ModalMelonTV'
import ModalSurvey from '@/views/components/modals/ModalSurvey'
import PwaPrompt from './components/PwaPrompt.vue'
import CampaignIntroduce from './components/CampaignIntroduce'
import TutorialBanner from './components/TutorialBanner.vue'
import moment from 'moment'

export default {
  name: 'Home',
  components: {
    ModalMelonTV,
    ModalSurvey,
    Schedule,
    Information,
    MelonTV,
    MindfulLog,
    Notification,
    Banner,
    Cotree,
    PwaPrompt,
    CampaignIntroduce,
    TutorialBanner
  },
  data() {
    return {
      scheduleForm: 0,
      isLoadingNotification: true,
      isLoadingMelonTV: true,
      isLoadingInformation: true,
      isLoadingBanner: true,
      isLoadingView: true,
      deferredPrompt: null
    }
  },
  computed: {
    isNewUser() {
      const userRegisterDate = this.$store.state.user.userInfo.created_at
      return moment().diff(moment(userRegisterDate).startOf('day'), 'days') <= 14
    }
  },
  mounted() {
    if (this.$store.state.user.tutorialCompleted === 0) {
      this.$router.push('/tutorial')
    }
  },
  created() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      console.log(`'beforeinstallprompt' event was fired.`)
    })

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null
      console.log('PWA was installed')
    })
  },
  methods: {
    reloadComponent() {
      this.scheduleForm++
    },
    updateLoadingBanner(value) {
      this.isLoadingBanner = value
      this.updateLoadingView()
    },
    updateNotification(value) {
      this.isLoadingNotification = value
      this.updateLoadingView()
    },
    updateLoadingMelonTV(value) {
      this.isLoadingMelonTV = value
      this.updateLoadingView()
    },
    updateLoadingInformation(value) {
      this.isLoadingInformation = value
      this.updateLoadingView()
    },
    updateLoadingView() {
      this.isLoadingView = this.isLoadingBanner || this.isLoadingInformation || this.isLoadingMelonTV || this.isLoadingNotification
      this.$store.dispatch('loading/updateLoading', this.isLoadingView)
    }
  }
}
</script>
